import http from '../httpService';
import axios from 'axios';
import {BASE_URL, token} from '../../utils/const';
import {getLanguage} from 'react-switch-lang'
export function getAllProcesses() {
  return http.get('/processes');
}

export function getAllSubProcesses(processId) {
  return http.get(`/subprocesses?processId.equals=${processId}`);
}

export function getAllDepartments() {
  return http.get('/departments-user-permission');
}

export function getKriReport(body){
  return http.get(`/key-indicators/key-indicator-report`, body)
}

export const getReport = (api, criteria, isCustom, customApi) => {
  let url = `${BASE_URL}/${api}${isCustom ? '&' : '?'}${criteria}`;
  if (customApi) {
    url = `${BASE_URL}/${api}&${criteria}`;
  }
  return axios({
    method: 'GET',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
      'accept-Language': getLanguage(),
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  });
};

export const getReportErr = (api, criteria, customApi) => {
  let url = `${BASE_URL}/${api}?${criteria}`;
  if (customApi) {
    url = `${BASE_URL}/${api}&${criteria}`;
  }
  return axios({
    method: 'GET',
    url: url,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
      'accept-Language': getLanguage(),
    },
  });
};

export const getTableReport = (api, userId, criteria, pageNumber) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/${api}/${userId}?page=${pageNumber}&size=20${criteria}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
      'accept-Language': getLanguage(),
    },
  });
}


export function sendStatement(dateStart,dateEnd,departmentId){
  return http.put(`risks/month-report?departmentId=${departmentId}&dateStart=${dateStart}&dateEnd=${dateEnd}`)
}
export const getAllUsers = (pageNumber) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/users?page=${pageNumber}&size=100&sort=firstName`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};
